export default ({ request }) => ({
  sysCustomerExportTemplateListApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/list',
      method: 'post',
      data,
    })
  },
})
